import React from 'react'
import { Box, Tooltip, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function ratingComparisonColumn() {

	const iconMap = {
		"Lower than": "less-than",
		"Higher than": "greater-than",
		"Different than": "not-equal"
	}

	const colorMap = {
		"Lower than": "error.main",
		"Higher than": "success.main",
		"Different than": "warning.main"
	}

	return {
		name: 'comparatorValue',
		label: "Condition",
		options: {
			customBodyRowRenderLite: (value, { comparatorName }) => <Box sx={{
				alignItems: "center",
				justifyContent: "center",
				display: "flex"
			}}>
				<IconSeeker
					tooltip={comparatorName}
					icon={iconMap[comparatorName]}
					sx={{
						mx: .7,
						color: colorMap[comparatorName],
						fontSize: 14
					}}
				/>
				<Tooltip title="Amount" placement="top" arrow>
					<Typography sx={{ fontWeight: "bold" }}>{`${value}`}</Typography>
				</Tooltip>
				<IconSeeker
					tooltip="Rating Score"
					icon="star-sharp"
					sx={{
						mx: .7,
						color: "warning.main",
						fontSize: 13
					}}/>
			</Box>
		}
	}
}